import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MonoLabel } from '../components/Editorial';

const AuthShell = ({ children }) => (
  <div className="ed-auth">
    <div className="ed-auth__hero">
      <div>
        <MonoLabel onDark>EMAIL CHANGE</MonoLabel>
        <h1 className="ed-auth__hero-headline" style={{ marginTop: 16 }}>
          One click<br /><em>away.</em>
        </h1>
      </div>
      <p className="ed-auth__hero-quote">
        "Confirming a new email address keeps your account in your hands."
      </p>
    </div>
    <div className="ed-auth__form-wrap">
      <div className="ed-auth__form">{children}</div>
    </div>
  </div>
);

export default function ConfirmEmailChangePage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const [state, setState] = useState(token ? 'pending' : 'no-token');
  const [error, setError] = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.post('/api/auth/confirm-email-change', { token });
        if (cancelled) return;
        setNewEmail(r.data?.email || '');
        setState('success');
        setTimeout(() => navigate('/login'), 4000);
      } catch (err) {
        if (cancelled) return;
        setError(err.response?.data?.detail || 'This confirmation link is invalid or has expired.');
        setState('error');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  return (
    <AuthShell>
      <div className="auth-logo" style={{ marginBottom: 24 }}>
        <img src="/logo.png" alt="ProZpects" style={{ maxHeight: 36 }} />
      </div>
      <MonoLabel>CONFIRM EMAIL</MonoLabel>
      <h2 style={{ fontFamily: 'var(--ed-font-serif)', fontSize: 36, fontWeight: 400, letterSpacing: '-0.015em', margin: '8px 0 24px' }}>
        {state === 'success' ? 'Email updated.' : state === 'error' ? 'Hmm.' : 'Confirming…'}
      </h2>

      {state === 'no-token' && (
        <div className="auth-error" role="alert">No confirmation token in this link.</div>
      )}
      {state === 'pending' && (
        <p>Hang tight — we're updating your email address now.</p>
      )}
      {state === 'success' && (
        <div className="auth-success" role="alert">
          Your email is now <strong>{newEmail}</strong>. You've been signed out for security; redirecting to login…
        </div>
      )}
      {state === 'error' && (
        <div className="auth-error" role="alert">
          {error}
          <div style={{ marginTop: '8px' }}>
            <Link to="/settings">Try again from Settings</Link>
          </div>
        </div>
      )}

      <div className="auth-footer" style={{ marginTop: 16 }}>
        <Link to="/login">Back to login</Link>
      </div>
    </AuthShell>
  );
}
